<template>
  <tr>
    <td class="text-center">
      <span class="form-control form-control-plaintext">{{rowIndex + 1}}</span>
    </td>
    <td class="form-group">
      <!-- <select2
        :css-style="'width: 100%;'"
        :css-class="'form-control required'"
        :id="'brandid' + _uid"
        :name="'brandid' + _uid"
        :select2-options="brandidOptions"
        v-model="item.Brandid"
        ref="brandid"
        data-msg-required="กรุณาเลือกแบรนด์"
      ></select2> --> 
      <input  class="form-control readonly" style="background-color: #f7f7f7;" readonly v-model="item.BrandName"> 
    </td>
    <td class="form-group">
      <input
        type="number"
        class="form-control required text-center"
        min="1"
        placeholder="จำนวน"
        :id="'days' + _uid"
        :name="'days' + _uid"
        v-model="item.Days"
        data-msg-required="กรุณากรอกจำนวนวัน"
      />
      <span class="form-text"></span>
    </td>
    <td class="form-group">

      
      <button
        type="button"
        class="btn m-btn--pill btn-info btn-block uploader-btn col-xl-12"
        :id="'f' + rowIndex"
        @click="doUpload(item,rowIndex)" 
      >
        <i class="flaticon-upload-1"></i>ไฟล์
      </button>

    </td>
    <td class="form-group">
        <a :href='item.DownloadFileUrl' target="_blank">{{item.FileName }}</a>
        <!-- ปุ่มลบ -->
        <button v-if="item.FileName"
                type="button"
                class="btn btn-sm btn-danger ml-2"
                @click="removeFile">
            <span class="m--font-inverse-danger la la-trash"></span>
        </button>
    </td>
   
    <!-- <td class="form-group">
      <center>
        <button
          type="button"
          class="btn btn-outline-hover-danger btn-elevate btn-circle btn-icon"
          @click.prevent="onRemoveItemClick"
        >
          <i class="text-danger la la-trash"></i>
        </button>
      </center>
    </td> -->
  </tr>
</template>

<script>
import select2 from "../../../Shared/Select2";
import plupload from "plupload";

export default {
  components: {
    select2
  },
  props: {
    isEditable: {
      type: Boolean,
      default: true
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    rowIndex: Number,
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    var self = this;

   

    return {
      
      uuid : null,
      // brandidOptions: {
      //   placeholder: "กรุณาเลือกแบรนด์",
      //   allowClear: true,
      //   ajax: {
      //     delay: 300,
      //     url: "/Api/Report/PM/ProductBrandOptions",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) { 
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more
      //         }
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     }
      //   }
      // },
        
    };
  },

  computed: {
    totalCal() {
      return (this.item.odcTotal = this.item.odcQuantity * this.item.odcPrice);
    }
  },
  methods: {
      removeFile() {
          Swal.fire({
              title: "ยืนยันคำสั่ง",
              text: "คุณต้องการลบรูปภาพนี้หรือไม่",
              confirmButtonText: "<span><i class='la la-check'></i><span>ฉันต้องการลบรูปภาพนี้</span></span>",
              confirmButtonClass: "btn btn-danger m-btn m-btn--pill m-btn--icon",
              showCancelButton: true,
              cancelButtonText: "<span><i class='la la-close'></i><span>ยกเลิก</span></span>",
              cancelButtonClass: "btn btn-secondary m-btn m-btn--pill m-btn--icon"
          }).then((result) => {
              if (result.value) {
                  setTimeout(() => {
                      // ล้างค่าที่เกี่ยวกับไฟล์ออกจาก item
                      this.item.FileInfoId = '';
                      this.item.GridFsId = '';
                      this.item.FileName = '';
                      this.item.DownloadFileUrl = '';
                      this.item.DownloadUrl = '';

                      Swal.fire("ลบสำเร็จ!", "ลบรูปภาพเรียบร้อยแล้ว", "success");
                  }, 500);
              }
          });
      },
    onRemoveItemClick(e) {
      this.$emit("removeItem", this.rowIndex, this.item);
    },
    doUpload(row,rowIndex){

      let self = this; 
      this.$parent.doUploadClick(self.item);
    },
    OpenFileUpload(url){

      alert(url);
      // Object.assign(document.createElement('a'), {
      //  // target: '_blank',
      //   download : 'download',
      //   rel: 'noopener noreferrer',
      //   href: url,
      // }).click();
    },

  },
  mounted() {
    



    $(".required", this.$el).each(function() {
      const $input = $(this);
      $input.rules("add", {
        required: true,
        messages: {
          required: $input.data("msg-required")
        }
      });
    });
  }
};
</script>

<style lang="scss" scoped>
    .btn-danger {
        color: #fff;
        background-color: #fa6999;
        border-color: #fa6999;
    }
    .btn-danger:hover {
        color: #fff;
        background-color: #fd1361;
        border-color: #fd1361;
    }
    
</style>


// WEBPACK FOOTER //
// App/Components/Master/AlertPMConfig/ItemRow.vue